<mat-card class="alert-card">
    <img
      src="../../../../assets/icons/Icon-atencao.svg"
      alt="Atenção"
    />
    <div>
      <mat-card-title class="card-title"
        >Aviso importante!</mat-card-title
      >
      <mat-card-content class="card-content">
        <p>
          {{ message }}
        </p>
      </mat-card-content>
    </div>
  </mat-card>

